export default "__VITE_ASSET__Bd2x82F0__"